/* Use ajaxCart.refreshCart() to refresh mini cart */
var pbVarID = 40347378876495;
var pbfVarID = 40384289275983;

function setPinkieBankCartView()
{
  jQuery.getJSON('/cart.js', function(cart) {
    var PBInCart = false;
    var anyPBInCart = false;
    var freePBInCart = false;
    var cartTotalWithoutPB = cart.total_price;
    var numPB = 0;
    var numFreePB = 0;
    //console.log(cart);
    
    cart.items.every(item => {
      //console.log(item);
      if(item.id == pbVarID)
	  {
        anyPBInCart = true;
        PBInCart = true;
        cartTotalWithoutPB = cartTotalWithoutPB - item.line_price;
        numPB = item.quantity;
      }
      else if(item.id == pbfVarID)
	  {
        anyPBInCart = true;
        freePBInCart = true;
        cartTotalWithoutPB = cartTotalWithoutPB - item.line_price;
        numFreePB = item.quantity; 
      }
      return true;
    });
    //console.log(cartTotalWithoutPB);

      if(anyPBInCart)
      {
        if(freePBInCart)
        {
          removePinkieBank(pbfVarID);
          /*
          if(!PBInCart)
          {
            addPinkieBank();
          }
          */
        }
        else
        {
          jQuery('.pinkie-bank-minicart-wrapper.add-bank input[type="checkbox"]').prop( "checked", true );
        }
      }

      jQuery('.pinkie-bank-minicart-wrapper #add-pb').click(function(e){
        if(jQuery(this).is(':checked'))
        {
          addPinkieBank(pbVarID, true);
        }
        else
        {
          removePinkieBank();
        }
      });
      
      jQuery('.pinkie-bank-minicart-wrapper.add-bank').show();
      jQuery('.pinkie-bank-minicart-wrapper.opt-bank').hide();
    
  }); 

}

function updatePinkieBanks(updateData, setCookie = false)
{
  jQuery.ajax({
    type: 'POST',
    url: '/cart/update.js', 
    data: {
      updates: updateData
    },
  	dataType: 'json',
  	success: function(data){
      if(setCookie)
      {
        document.cookie = 'optPB=1;path=/';
      }
      ajaxCart.refreshCart();
  	},
    async: false
  });    
}

function addPinkieBank(variantID = pbVarID, setCookie = false)
{
  let variantData = { //Post the below in the cart
    quantity: 1, 
    id: variantID
  };
  
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js', 
    data: variantData,
    dataType: 'json',
    success: function(data){
      if(setCookie)
      {
        document.cookie = 'optPB=1;path=/';
      }
  	  ajaxCart.refreshCart();
    }
  });    
}

function removePinkieBank(variantID = pbVarID, setCookie = false, qty = 0)
{
  let updateData = {};
  updateData[variantID] = qty;
  
  jQuery.ajax({
    type: 'POST',
    url: '/cart/update.js', 
    data: {
      updates: updateData
    },
  	dataType: 'json',
  	success: function(data){
      if(setCookie)
      {
        document.cookie = 'optPB=0;path=/';
      }
      ajaxCart.refreshCart();
  	},
    async: false
  });    
}


function getPBCookie(cookiename) {
  let name = cookiename + "=";
  let spli = document.cookie.split(';');
  for(var j = 0; j < spli.length; j++) {
    let char = spli[j];
    while (char.charAt(0) == ' ') {
      char = char.substring(1);
    }
    if (char.indexOf(name) == 0) {
      return char.substring(name.length, char.length);
    }
  }
  return "";
}
